import React, { useState, useEffect } from "react";
import BuyWidget from "../moonpay/MoonPayWidget";
import Button from "react-bootstrap/Button";
import messages from "../../constants/messages";
import { useSelector } from "react-redux";
import axios from "axios";
import Swal from "sweetalert2";

const MoonPayView = ({
  userInput,
  wallet,
  isOpen,
  setIsOpen,
  setBuyAmount,
  walletAddress,
  error,
  setError,
}) => {
  const user = useSelector((state) => state.userStore.user);
  const token = user.auth;

  const [visible, setVisible] = useState(false);
  const [loading, setLoading] = useState(false);

  const Email = localStorage.getItem("user")
    ? JSON.parse(localStorage.getItem("user")).email
    : "";

  const handleConnectWallet = () => {
    setIsOpen(!isOpen);
  };

  const fetchUserWalletAddress = async () => {
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_ENDPOINT_URL}/users/userWalletAddress`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      const storedWalletAddress = response.data?.walletAddress?.walletAddress;
      return storedWalletAddress;
    } catch (error) {
      console.error("Failed to fetch user wallet address", error);
      throw error;
    }
  };

  const handleBuyNowClick = async () => {
    if (userInput <= 0) {
      setError(messages.errors.solRequired);
    } else {
      const storedWallet = await fetchUserWalletAddress();
      console.log("storedWallet", storedWallet);
      console.log("walletAddress", walletAddress);
      if (walletAddress !== storedWallet) {
        Swal.fire({
          title: "Wallet Mismatch",
          text: messages.errors.walletMismatch,
          icon: "warning",
          confirmButtonText: "OK",
        });
        return;
      }
      setError("");
      setVisible(true);
      setLoading(true);
    }
  };

  return (
    <>
      {wallet ? (
        <>
          <div className="wallet-input">
            <div className="connect-wallet">
              <div className="connect-wallet-one">
                <Button onClick={handleBuyNowClick} disabled={loading}>
                  {loading ? (
                    <span
                      className="spinner-border spinner-border-sm"
                      role="status"
                      aria-hidden="true"
                    ></span>
                  ) : (
                    "Buy Now"
                  )}
                </Button>
              </div>
              {visible ? (
                <BuyWidget
                  visible={visible}
                  email={Email}
                  walletAddress={walletAddress}
                  userInput={userInput}
                  setBuyAmount={setBuyAmount}
                  setLoading={setLoading}
                />
              ) : (
                ""
              )}
            </div>
            {error && <p>{error}</p>}
          </div>
        </>
      ) : (
        <div className="connect-wallet-one">
          <button onClick={handleConnectWallet}>Connect Wallet</button>
        </div>
      )}
    </>
  );
};

export default MoonPayView;
